// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__NEHh5","choiceBoxes":"toolbarselects_choiceBoxes__2zEq4","simpleField":"toolbarselects_simpleField__1CVGt"};